import { create } from "zustand";

interface UiState {
  catalogQuery: string;
  activeCategory: string;
  sidebarOpen: boolean;
  showDesktopApps: boolean;
  setShowDesktopApps: (value: boolean) => void;
  setCatalogQuery: (value: string) => void;
  setActiveCategory: (value: string) => void;
  setSidebarOpen: (value: boolean) => void;
}

export const useUiStore = create<UiState>((set) => ({
  catalogQuery: "",
  activeCategory: "All",
  sidebarOpen: false,
  showDesktopApps: (() => { try { return localStorage.getItem("cheesyapps:show-desktop-apps") === "true"; } catch { return false; } })(),
  setShowDesktopApps: (showDesktopApps) => {
    try { localStorage.setItem("cheesyapps:show-desktop-apps", String(showDesktopApps)); } catch { /* Storage is optional. */ }
    set({ showDesktopApps });
  },
  setCatalogQuery: (catalogQuery) => set({ catalogQuery }),
  setActiveCategory: (activeCategory) => set({ activeCategory }),
  setSidebarOpen: (sidebarOpen) => set({ sidebarOpen }),
}));
